(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const nameInput = document.getElementById("ContactForm-name");
  const phoneInput = document.getElementById("ContactForm-phone");

  // Prevent numbers in the Name field
  nameInput.addEventListener("input", function () {
    this.value = this.value.replace(/[0-9]/g, ""); // removes digits
  });

  // Prevent alphabets in the Phone field
  phoneInput.addEventListener("input", function () {
    this.value = this.value.replace(/[^0-9\-+]/g, ""); 
    // allows only digits, dash, plus sign
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
